import { createAxiosClient } from '../axiosDefaults';
export function createApi(baseUrl, config) {
  let axiosConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const axiosInstance = createAxiosClient({
    baseURL: baseUrl + "/marketing-questionnaire",
    withCredentials: true,
    ...axiosConfig
  }, config);
  return {
    fetchQuestionnaire,
    submitQuestion,
    submitQuestionnaire,
    completeQuestionnaire
  };

  function fetchQuestionnaire(questionnaireId) {
    return axiosInstance.get("/" + questionnaireId).then(r => {
      return r.data;
    });
  }

  function submitQuestion(questionnaireId, question) {
    return axiosInstance.post("/" + questionnaireId + "/question", {
      question
    }).then(r => {
      return r.data;
    });
  }

  function submitQuestionnaire(questionnaireType) {
    let questions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return axiosInstance.post("/", {
      type: questionnaireType,
      questions
    }).then(r => {
      return r.data;
    });
  }

  function completeQuestionnaire(questionnaireId, data) {
    return axiosInstance.patch("/" + questionnaireId, data, {
      headers: {
        'Content-Type': 'application/json-patch+json'
      }
    });
  }
}